<script lang="ts">
    import { replace } from "svelte-spa-router";

    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import LogoBos from "../../logos/logo-bos.svelte";
    import LogoBrickle from "../../logos/logo-brickle.svelte";
    import LogoDt from "../../logos/logo-dt.svelte";
    import LogoEtf from "../../logos/logo-etf.svelte";
    import LogoEurocommand from "../../logos/logo-eurocommand.svelte";
    import LogoHannoverAirport from "../../logos/logo-hannover-airport.svelte";
    import LogoHenkel from "../../logos/logo-henkel.svelte";
    import LogoHytera from "../../logos/logo-hytera.svelte";
    import LogoIhm from "../../logos/logo-ihm.svelte";
    import LogoIse from "../../logos/logo-ise.svelte";
    import LogoKenwood from "../../logos/logo-kenwood.svelte";
    import LogoKleinItk from "../../logos/logo-klein-itk.svelte";
    import LogoKnuerr from "../../logos/logo-knuerr.svelte";
    import LogoKoelnBonnAirport from "../../logos/logo-koeln-bonn-airport.svelte";
    import LogoLis from "../../logos/logo-lis.svelte";
    import LogoNoratec from "../../logos/logo-noratec.svelte";
    import LogoObjektPlusDesign from "../../logos/logo-objekt-plus-design.svelte";
    import LogoRedcar from "../../logos/logo-redcar.svelte";
    import LogoSeb from "../../logos/logo-seb.svelte";
    import LogoSwissphone from "../../logos/logo-swissphone.svelte";
    import LogoTSystems from "../../logos/logo-t-systems.svelte";
    import LogoVivasecur from "../../logos/logo-vivasecur.svelte";
    import LogoWtg from "../../logos/logo-wtg.svelte";
    import LogoInnovaphone from "../../logos/logo-innovaphone.svelte";
    import { t } from "../../helpers/translation";
    import LogoStatus3it from "../../logos/logo-status3it.svelte";
    import LogoPeitel from "../../logos/logo-peitel.svelte";
    import LogoSecurepoint from "../../logos/logo-Securepoint.svelte";

    type Partner = {
        name?: string;
        logo: any; // svelte component
        url: string;
    };
    const partners: Partner[] = [
        {
            logo: LogoObjektPlusDesign,
            url: "www.objektplusdesign.de",
        },
        {
            logo: LogoBos,
            url: "www.bos-mobile.de",
        },
        {
            logo: LogoIhm,
            url: "www.ihm.dk",
        },
        {
            logo: LogoRedcar,
            url: "www.redcar.de",
        },
        {
            logo: LogoSwissphone,
            url: "www.swissphone.com",
        },
        {
            logo: LogoEtf,
            url: "www.etf-eisleben.de",
        },
        {
            logo: LogoKleinItk,
            url: "www.klein-itk.de",
        },
        {
            logo: LogoDt,
            url: "www.dt-digitaltechnik.de",
        },
        {
            logo: LogoIse,
            url: "ise-hosting.de/",
        },
        {
            logo: LogoLis,
            url: "www.lis-gmbh.com",
        },
        {
            logo: null,
            url: "www.motorolasolutions.com",
        },
        {
            logo: LogoEurocommand,
            url: "www.eurocommand.com",
        },
        {
            logo: LogoWtg,
            url: "www.wtg.com",
        },
        {
            logo: LogoKnuerr,
            url: "www.knuerr-consoles.com/",
        },
        {
            logo: LogoBrickle,
            url: "www.bsk-world.de",
        },
        {
            logo: LogoVivasecur,
            url: "www.vivasecur.de",
        },
        {
            logo: LogoKenwood,
            url: "www.kenwood.de/comm/",
        },
        {
            logo: LogoHytera,
            url: "hytera-europe.com/",
        },
        {
            logo: LogoTSystems,
            url: "www.t-systems-ifs.com/",
        },
        {
            logo: LogoSeb,
            url: null,
        },
        {
            logo: LogoNoratec,
            url: "www.noratec-gmbh.com/",
        },
        {
            logo: LogoStatus3it,
            url: "www.status3.it/",
        },
        {
            logo: LogoInnovaphone,
            url: "www.innovaphone.com/",
        },
        {
            logo: LogoPeitel,
            url: "www.peitel.com/de/",
        },
        {
            logo: LogoSecurepoint,
            url: "www.securepoint.de/",
        },
    ];
</script>

<LightTheme />

<Hero headline={$t("page.partner.hero.headline")} small />

<Container>
    <Headline>
        {@html $t("page.partner.headline")}
    </Headline>
    <Subline>
        {@html $t("page.partner.subline")}
    </Subline>
    <p>
        {@html $t("page.partner.p")}
    </p>
    <Gap />

    <div class="partner-container">
        {#each partners as partner}
            {#if partner.logo}
                <svelte:element
                    this={partner.url ? "a" : "div"}
                    href={partner.url ? "https://" + partner.url : null}
                    target={partner.url ? "_blank" : null}
                    class="partner"
                    class:is_link={partner.url != ""}
                >
                    <svelte:component this={partner.logo} />
                </svelte:element>
            {/if}
        {/each}
    </div>
</Container>

<Gap height="8rem" />

<style lang="scss">
    @import "../../vars";

    .partner-container {
        margin-top: 4rem;
        display: grid;
        gap: 4em;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        .partner {
            height: 100%;
            max-height: 4rem;
            width: auto;
            &.is_link {
                &:hover {
                    :global(*) {
                        fill: $green !important;
                    }
                }
            }
            :global(svg) {
                width: 100%;
                height: 100%;
            }
            :global(*) {
                fill: $grayDark !important;
                stroke: none !important;
                transition: 0.2s;
            }
        }
    }
</style>
